module.exports = "<span class=source-ref ng-click=openSource()> <span class=source-ref_text ng-transclude></span> </span>";